// Only X's photo CDN is accepted. Keep this policy aligned with the server.
function normalizeXMedia(value, preview = false) {
  if (typeof value !== 'string' || value.length > 512) return null;
  try {
    const url = new URL(value);
    if (url.protocol !== 'https:' || url.hostname !== 'pbs.twimg.com' || url.port || url.username || url.password || url.hash) return null;
    const photo = url.pathname.match(/^(\/media\/[a-zA-Z0-9_-]{1,100})(?:\.(jpg|jpeg|png|webp))?$/);
    const path = photo || (preview && url.pathname.match(/^(\/(?:ext_tw_video_thumb\/\d{1,25}\/pu\/img|amplify_video_thumb\/\d{1,25}\/img|tweet_video_thumb)\/[a-zA-Z0-9_-]{1,100})(?:\.(jpg|jpeg|png|webp))?$/));
    if (!path || [...url.searchParams.keys()].some(key => !['format', 'name'].includes(key)) ||
        url.searchParams.getAll('format').length > 1 || url.searchParams.getAll('name').length > 1) return null;
    const format = url.searchParams.get('format') || path[2];
    if (!['jpg', 'jpeg', 'png', 'webp'].includes(format) || (path[2] && path[2] !== format)) return null;
    if (url.searchParams.has('name') && !['thumb', 'small', 'medium', 'large', 'orig', '4096x4096', '900x900'].includes(url.searchParams.get('name'))) return null;
    return photo ? `https://pbs.twimg.com${path[1]}?format=${format}&name=large` : `https://pbs.twimg.com${path[1]}.${format}`;
  } catch { return null; }
}
export const normalizeXPhoto = value => normalizeXMedia(value);
export const normalizeXVideoPreview = value => normalizeXMedia(value, true);

export function xReplyContext(value) {
  if (!value || typeof value.postId !== 'string' || !/^\d{1,25}$/.test(value.postId) ||
      !Array.isArray(value.contextChain) || !value.contextChain.length || value.contextChain.length > 10) return null;
  let total = 0, imageCount = 0;
  const contextChain = [];
  for (const item of value.contextChain) {
    if (!item || typeof item.author !== 'string' || item.author.length > 200 ||
        typeof item.content !== 'string' || item.content.length > 10000) return null;
    const raw = item.images === undefined ? [] : item.images;
    if (!Array.isArray(raw) || raw.length > 4) return null;
    const images = raw.map(normalizeXPhoto);
    const rawPreviews = item.videoPreviews === undefined ? [] : item.videoPreviews;
    if (!Array.isArray(rawPreviews) || raw.length + rawPreviews.length > 4) return null;
    const videoPreviews = rawPreviews.map(normalizeXVideoPreview);
    if (images.some(url => !url) || videoPreviews.some(url => !url) || (!item.content.trim() && !images.length && !videoPreviews.length)) return null;
    total += item.content.length; imageCount += images.length + videoPreviews.length;
    if (total > 20000 || imageCount > 8) return null;
    contextChain.push({ author: item.author, content: item.content, ...(images.length ? { images } : {}), ...(videoPreviews.length ? { videoPreviews } : {}) });
  }
  return { postId: value.postId, contextChain };
}
